export const FETCH_D2C_REQUEST = 'FETCH_D2C_REQUEST';
export const FETCH_D2C_EVENT = 'FETCH_D2C_EVENT';
export const FETCH_D2C_DATA = 'FETCH_D2C_DATA';
export const FETCH_D2C_ERROR = 'FETCH_D2C_ERROR';
export const RESET_D2C_VIEW_DATA = 'RESET_D2C_VIEW_DATA';
